<template>
   <div class="layout-contain">
      <div class="layout-nav">
         <div id="header" class="grow container-fluid">
            <div class="row">
               <div class="col">
                  <div class="header-logo"></div>
               </div>
               <div class="col d-none d-lg-block text-right">
                  <h2 class="large-title-block">{{ appTitle }}</h2>
               </div>
            </div>
         </div>
      </div>
      <div class="layout-page-anon">
         <slot />
      </div>

      <div class="layout-footer container-fluid">Copyright &copy; {{ year }} MANHATTANLIFE</div>
   </div>
</template>   

<script>
import Vue from "vue";
const TIMEOUT = 20;

export default {
   name: "AnonLayout",
   data() {
      return {
         windowHeight: 0,
         windowWidth: 0,
         appTitle: process.env.VUE_APP_TITLE,
         year: new Date().getFullYear(),
      };
   },
   mounted() {
      window.addEventListener("resize", () => {
         this.windowChangedSize();
      });
      window.addEventListener("scroll", this.handleScroll);

      if (this.$route.hash) {
         setTimeout(() => this.scrollTo(this.$route.hash), TIMEOUT);
      }
   },
   beforeDestroy() {
      window.removeEventListener("resize", () => {
         this.windowChangedSize();
      });
      window.removeEventListener("scroll", this.handleScroll);
   },
   methods: {
      scrollTo(hashtag) {
         setTimeout(() => {
            location.href = hashtag;
         }, TIMEOUT);
      },
      windowChangedSize: function () {
         this.windowHeight = window.innerHeight;
         this.windowWidth = window.innerWidth;
      },
      handleScroll() {
         // Resize the header when the user scrolls
         var startShrink = 80;
         var he = document.getElementById("header");
         if (window.pageYOffset > startShrink) {
            he.classList.remove("grow");
            he.classList.add("shrink");
         } else {
            he.classList.remove("shrink");
            he.classList.add("grow");
         }
      },
   },
};
</script>

<style lang="scss" scoped>
@import "./src/assets/css/site.scss";
.layout-contain {
   background-color: #000;
}
.layout-footer {
   height: 36px;
   font-size: 12px;
   font-weight: 100;
   line-height: 12px;
   color: $corp-color;
   background-color: #000;
   padding: 12px;
   display: flex;
   flex-direction: column;
}
</style>